import { TextV2 } from '@withjoy/joykit';
import { LayoutAddComponentListItem } from '@website-editor/features/custom-page/components/LeftPanelLayouts/LayoutAddComponentListItem';
import { useCreateNewJsonComponent } from '../../hooks/useJsonBlobStorageUtils';
import React from 'react';
import { Profile } from '@withjoy/joykit/icons';
import { AdminSidebarComponentProps } from '../../JsonComponent.types';
import { SimpleGrabHandle } from '../SimpleGrabHandle';
import { VipConfig } from './Vip.config';
import { useTranslation } from '@shared/core';
import { useNavigationPaneContext } from '@website-editor/context/NavigationPaneContext/NavigationPane.context';
import { useUpdateWebsitePreview } from '@website-editor/hooks/useUpdateWebsitePreview';
import { useCustomComponentStateContext } from '@website-editor/features/custom-page/context/CustomComponentStateContext/CustomComponentState.context';
import { JsonDataContainerFragment } from '@graphql/generated';
import { CUSTOM_PAGE_ACTIONS } from '../../../CustomComponents.constants';

export const VipGrabber = (props: AdminSidebarComponentProps) => {
  const { tq } = useTranslation('VIPCustomComponent');

  return (
    <SimpleGrabHandle
      title={tq`VIPs`}
      icon={<Profile size={32} />}
      {...props}
    ></SimpleGrabHandle>
  );
};

export const VipAdd = (props: AdminSidebarComponentProps) => {
  const { createNewJsonComponent } = useCreateNewJsonComponent(props.eventHandle);
  const { setRefetchQueries } = useCustomComponentStateContext<JsonDataContainerFragment>();
  const { replaceAndNavigateToScreen } = useNavigationPaneContext();
  const { updateWebsitePreview } = useUpdateWebsitePreview();
  const { tq } = useTranslation('VIPCustomComponent');

  const handleClick = () => {
    createNewJsonComponent({
      schemaURL: VipConfig.schemaUrl,
      type: VipConfig.schemaUrl,
      initialData: {},
      containerId: props.containerId,
      sortOrder: props.componentData.sortOrder,
    }).then(result => {
      if (result?.containerData?.data) {
        // Request a refetch of the components list to update the left panel
        setRefetchQueries(['PageContainerBySlug']);

        // Then update the preview
        updateWebsitePreview();

        // Finally replace and navigate to ensure proper left panel update
        replaceAndNavigateToScreen(CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS);
      }
    });
  };

  return (
    <LayoutAddComponentListItem onClick={handleClick}>
      <Profile size={48} />
      <TextV2
        typographyVariant="hed2"
        textAlign="left"
      >
        {tq`VIPs`}
      </TextV2>
    </LayoutAddComponentListItem>
  );
};
